const Report = () =>
  import(/* webpackChunkName: "orders" */ '@/pages/order/orders/index.vue')
const Detail = () =>
  import(/* webpackChunkName: "orders" */ '@/pages/order/orders/detail.vue')
const AssignDriver = () =>
  import(
    /* webpackChunkName: "orders" */ '@/pages/order/orders/assign-driver/index.vue'
  )
const ShippingSteps = () =>
  import(
    /* webpackChunkName: "orders" */ '@/pages/order/orders/shipping-steps/index.vue'
  )

export default {
  path: 'orders',
  meta: {
    label: 'shipmentReport',
    auth: 'order.order'
  },
  component: {
    name: 'Orders',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'OrdersReport',
      path: '',
      meta: {
        title: 'nav.shipmentReport',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'OrderDetail',
      path: ':id',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail,
      props: true
    },
    {
      name: 'OrderAssignDriver',
      path: 'assign-driver/:loadId/:courierId',
      meta: {
        label: 'Appropriation',
        auth: 'assignCourierDriver'
      },
      component: AssignDriver,
      props: true
    },
    {
      name: 'OrderShippingSteps',
      path: 'shipping-steps/:id',
      meta: {
        // Todo: Add auth
        label: 'LoadSteps',
        auth: true
      },
      component: ShippingSteps,
      props: true
    }
  ]
}
